// Clean Modern Boot Scene - Implements your exact design
import { auth } from "../firebaseConfig.js";
import { MobileDetectionService } from "../services/MobileDetectionService.js";
import { hasSpecialAccess } from "../services/specialAccessService.js";
import sceneManager from "../utils/SceneManager.js";

export default class BootSceneDOM extends Phaser.Scene {
  constructor() {
    super({ key: "BootSceneDOM" });
    this.loadStartTime = 0;
    this.targetScene = null;
    this.transitionStarted = false;
  }

  preload() {
    this.loadStartTime = Date.now();
    
    // Load only essential assets that exist
    const assets = [
      { key: 'player', path: 'assets/player.png' },
      { key: 'asteroid', path: 'assets/asteroid.png' },
      { key: 'greenAsteroid', path: 'assets/greenAsteroid.png' },
      { key: 'brick', path: 'assets/brick.png' }
    ];

    assets.forEach(asset => {
      this.load.image(asset.key, asset.path);
    });
  }

  create() {
    console.log("Clean Modern Boot Scene: Starting");
    
    // The clean HTML is now in index.html - just start the loading sequence
    this.startCleanInitialization();
  }
  
  // REMOVED: HTML replacement methods - clean HTML is now in index.html directly

  async startCleanInitialization() {
    // Your clean initialization tasks
    const tasks = [
      { name: 'Checking authentication', weight: 15, delay: 300 },
      { name: 'Loading user data', weight: 35, delay: 400 },
      { name: 'Establishing connection', weight: 60, delay: 300 },
      { name: 'Loading workspace', weight: 85, delay: 400 },
      { name: 'Preparing interface', weight: 100, delay: 300 }
    ];
    
    // Show quick status after initial load
    setTimeout(() => {
      const quickStatus = document.getElementById('quickStatus');
      if (quickStatus) {
        quickStatus.classList.add('visible');
        this.updateQuickStatus();
      }
    }, 500);
    
    // Execute tasks
    for (const task of tasks) {
      this.updateStatus(task.name);
      this.updateProgress(task.weight);
      
      // Update metrics based on progress
      if (task.weight >= 35) {
        this.updateMetric('latency', Math.round(20 + Math.random() * 30) + 'ms');
      }
      if (task.weight >= 60) {
        this.updateMetric('cached', Math.round(3 + Math.random() * 5) + ' files');
      }
      if (task.weight >= 85) {
        this.updateMetric('version', 'v34.0.0');
      }
      
      await this.delay(task.delay);
    }
    
    // Determine target scene
    this.determineTargetScene();
    
    // Complete loading
    this.completeLoading();
  }
  
  updateProgress(percent) {
    const progressFill = document.getElementById('progressFill');
    if (progressFill) {
      progressFill.style.width = percent + '%';
    }
  }
  
  updateStatus(status) {
    const statusElement = document.getElementById('loadingStatus');
    if (statusElement) {
      statusElement.innerHTML = status + '<span class="loading-dot">.</span><span class="loading-dot">.</span><span class="loading-dot">.</span>';
    }
  }
  
  updateMetric(metricId, value) {
    const element = document.getElementById(metricId);
    if (element) {
      element.textContent = value;
    }
  }
  
  updateQuickStatus() {
    // Initialize with measuring state
    this.updateMetric('latency', 'Measuring...');
    this.updateMetric('cached', 'Scanning...');
    this.updateMetric('version', 'v34.0.0');
  }
  
  determineTargetScene() {
    // Preserve your existing routing logic
      const user = auth.currentUser;
    const specialAccess = hasSpecialAccess();
    const isLoggedIn = (user && user.emailVerified) || specialAccess;
    
    if (isLoggedIn) {
        // FIXED: Always use AuthenticatedMenuSceneDOM for both mobile and desktop
        // Mobile/desktop template selection happens within the scene
        this.targetScene = "AuthenticatedMenuSceneDOM";
        } else {
      this.targetScene = "GuestMenuSceneDOM";
    }
    
    console.log('Clean Boot: Target determined:', this.targetScene);
  }

  completeLoading() {
    this.updateStatus("Ready");
    
    // Seamless transition
    setTimeout(() => {
      if (this.transitionStarted) return;
    this.transitionStarted = true;
    
      // SHOW THE CLEAN INTERFACE: Don't hide immediately!
      console.log("🎯 Clean boot interface should be visible now - showing for 2 seconds");
      
      // Hide preloader after showing the clean interface
      setTimeout(() => {
        const preloader = document.getElementById('preloader');
        if (preloader) {
          preloader.style.display = 'none';
          console.log("🔍 Hiding preloader after showing clean interface");
        }
      }, 2000); // Show clean interface for 2 seconds
      
      // Also call preloader hide function
    if (window.preloader && window.preloader.hide) {
      window.preloader.hide();
      }
      
      // Then start target scene
      if (sceneManager && sceneManager.switchToScene) {
        sceneManager.switchToScene(this.targetScene);
      } else {
        this.scene.start(this.targetScene);
      }
    }, 500);
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}